import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Signup() {
    const { signup } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try { await signup(form); toast.success("Account created"); nav("/"); }
        catch (e) { toast.error(e.response?.data?.detail || "Signup failed"); }
        finally { setLoading(false); }
    };

    return (
        <div className="max-w-[440px] mx-auto px-4 py-16" data-testid="signup-page">
            <div className="font-mono text-[10px] uppercase text-neutral-500">Signup</div>
            <h1 className="font-display text-5xl tracking-tighter mt-1">Join Clonzo.</h1>
            <form onSubmit={submit} className="mt-8 space-y-4">
                {[
                    ["name", "Full name", "text", true],
                    ["email", "Email", "email", true],
                    ["phone", "Phone (optional)", "tel", false],
                    ["password", "Password (min 6)", "password", true],
                ].map(([k, l, t, req]) => (
                    <label key={k} className="block">
                        <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">{l}</div>
                        <input required={req} minLength={k === "password" ? 6 : undefined} type={t} value={form[k]} onChange={e => setForm({...form, [k]: e.target.value})} className="w-full border-2 border-black p-3 font-mono" data-testid={`signup-${k}`} />
                    </label>
                ))}
                <button disabled={loading} type="submit" className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest brutal-shadow" data-testid="signup-submit">{loading ? "…" : "Create Account"}</button>
            </form>
            <div className="mt-4 font-mono text-xs">Have an account? <Link to="/login" className="underline">Login →</Link></div>
        </div>
    );
}
